import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IconFilterlines, IconSearchLg } from "@pentabd/icons";
import { Button, Input, Table } from "@pentabd/ui";
import { FloorTableColumn } from "./FloorTableColumn";

export default function FloorListTable() {
  const { t } = useTranslation();
  const { control } = useForm();
  return (
    <div className="pt-12 border-top">
      <Table
        header={{
          title: t("INVENTORY_ROOM_CONFIG.FLOOR.HEADER"),
          badge: {
            label: `12546`,
            size: "sm",
            type: "primary",
          },

          buttons: [
            <Controller
              name={"FLOOR_SEARCH"}
              control={control}
              render={() => (
                <Input
                  key="FLOOR_SEARCH"
                  name="FLOOR_SEARCH"
                  outline
                  placeholder="search"
                  prefix={<IconSearchLg height="20" width="20" />}
                  size="sm"
                  type="text"
                  onChange={() => {}}
                  controlling
                />
              )}
            />,
            <Button
              fill="outline"
              type="light"
              size="sm"
              onClick={() => {
                console.log("filter button clicked");
              }}
              className="ms-5"
            >
              <IconFilterlines fill="dark" size="17" />
              {t("INVENTORY_ROOM_CONFIG.FLOOR.TABLE_FILTER_BUTTON.BUTTON_TEXT")}
            </Button>,
          ],
        }}
        columns={FloorTableColumn(t)}
        // edit={{
        //     customIcon: <IconEdit01 size={24} fill="subtitle1" />,
        //     onClick: (id) => { },
        // }}
        // remove={{
        //     customIcon: <IconTrash01 size={24} fill="subtitle1" />,
        //     onClick: (id) => { },
        // }}
        rows={[]}
        //   pagination={{
        //     totalPage: Math.ceil(total / size),
        //     onClick: (currentPage) => handleQuery("page", currentPage),
        //     activePage: page,
        //   }}
        pagination={{
          totalPage: 12,
        }}
      />
    </div>
  );
}
